// import { getUserInfo, openTenant } from '@/api/oauth2/user'
import { get } from '@/api/platform/system/permissions'

export default {
  namespaced: true,
  state: {
    // 权限串
    permissions: []
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set({ state, dispatch }, dictData) {
      return new Promise(async resolve => {
        // store 赋值
        state.permissions = dictData
        // 持久化
        await dispatch('ibps/db/set', {
          dbName: 'sys',
          path: 'permissions.info',
          value: dictData,
          user: false
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     */
    get({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.permissions = await dispatch('ibps/db/get', {
          dbName: 'sys',
          path: 'permissions.info',
          defaultValue: {},
          user: false
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取权限数据
     * @param {Object} context
     */
    load({ state, dispatch }) {
      // console.log('load')
      return new Promise(async(resolve, reject) => {
        await get().then(async response => {
          if (!response.data) {
            reject(response.data)
          }

          // 设置当前
          await dispatch('set', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}
